import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useWindowScrollDirection } from '@display-component/pc';
import { useRouter } from 'next/router';
import querystring from 'query-string';
import _ from 'lodash';
import { AgentWithAgency } from '@remodeling/shop';

interface UseExpertDetail {
  detailData: AgentWithAgency;
}

const useExpertDetail = ({ detailData }: UseExpertDetail) => {
  const [isShowSticky, setIsShowSticky] = useState<boolean>(false);

  const profileAreaRef = useRef<any>(null);

  const router = useRouter();
  const { y } = useWindowScrollDirection();

  const isBestRD = useMemo(() => {
    const index = _.findIndex(detailData.agentDetail.reputations, {
      code: 'RD_RPT_01',
    });

    return index >= 0;
  }, [detailData.agentDetail.reputations]);

  const handleRequestConsult = useCallback(async () => {
    const options = {
      channelType: 'OP23_01',
      channelId: detailData.agency.upperId || detailData.agency.id,
      agentEmployeeNo: detailData.agentDetail.code,
      channelUrl: `${process.env.NEXT_PUBLIC_WEB_HOST}/expert/${detailData.agentDetail.code}`,
    };

    router.push(`/seq-consult?${querystring.stringify(options)}`);
  }, [
    detailData.agency.id,
    detailData.agency.upperId,
    detailData.agentDetail.code,
    router,
  ]);

  const goList = useCallback(() => {
    router.push('/expert/search');
  }, [router]);

  useEffect(() => {
    if (profileAreaRef && y && y > profileAreaRef.current.clientHeight + 48)
      setIsShowSticky(true);
    if (profileAreaRef && y && y <= profileAreaRef.current.clientHeight + 48)
      setIsShowSticky(false);
  }, [y]);

  return {
    isShowSticky,
    profileAreaRef,
    isBestRD,
    handleRequestConsult,
    goList,
  };
};

export default useExpertDetail;
